<div class="wrap-subscribe">
  <h3 class="h3-title">Subscribe to our newsletter to stay updated</h3>
  <form class="Subscribe-form" [formGroup]="subscribeForm">

    <div class="form-outline d-flex form-white">
      <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M1.63631 2.68173C1.33506 2.68173 1.09085 2.92594 1.09085 3.22718V9.77262C1.09085 10.0739 1.33506 10.3181 1.63631 10.3181H10.3636C10.6648 10.3181 10.909 10.0739 10.909 9.77262V3.22718C10.909 2.92594 10.6648 2.68173 10.3636 2.68173H1.63631ZM-5.28844e-05 3.22718C-5.28844e-05 2.32344 0.732571 1.59082 1.63631 1.59082H10.3636C11.2673 1.59082 11.9999 2.32344 11.9999 3.22718V9.77262C11.9999 10.6764 11.2673 11.409 10.3636 11.409H1.63631C0.732571 11.409 -5.28844e-05 10.6764 -5.28844e-05 9.77262V3.22718Z"
          fill="black" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M0.0850324 3.48009C0.246599 3.22584 0.583688 3.1507 0.837942 3.31227L5.72893 6.42025C5.81025 6.47088 5.90413 6.49773 5.99994 6.49773C6.09574 6.49773 6.18963 6.47088 6.27094 6.42025L6.27216 6.41949L11.1619 3.31227C11.4162 3.1507 11.7533 3.22584 11.9148 3.48009C12.0764 3.73435 12.0013 4.07144 11.747 4.233L6.85136 7.34396C6.59616 7.50385 6.30109 7.58863 5.99994 7.58863C5.69879 7.58863 5.40372 7.50384 5.14852 7.34395L5.14557 7.3421L0.252859 4.233C-0.00139545 4.07144 -0.076534 3.73435 0.0850324 3.48009Z"
          fill="black" />
      </svg>

      <input type="text" id="email" name="email" class="form-control" formControlName="email"
        placeholder="abc@example.com" />
      <div *ngIf="
          subscribeForm.controls['email'].touched &&
          subscribeForm.controls['email'].invalid &&
          subscribeForm.controls['email'].dirty" class="invalid-feedback" role="alert">
        <span *ngIf="subscribeForm?.controls['email']?.errors?.required">This field is required.</span>
        <span *ngIf="subscribeForm?.controls['email']?.errors?.url">Required a valid URL.</span>
        <span *ngIf="subscribeForm?.controls['email']?.errors?.email">Required a valid Email.</span>
      </div>
      <button type="submit" class="btn btn-dark-blue-bg" (click)="subscribeNewsLetter()">
        Subscribe
      </button>
    </div>

  </form>
</div>
